import axios from "axios";

axios.defaults.timeout = 600000;

const LOCAL_STAGING_API_BASEURL = "https://api.matchcatch.com/"

function getApiBaseUrl() {
  const runtime = window.RUNTIME_CONFIG?.REACT_APP_API_BASEURL;
  if (runtime) {
    return runtime;
  }
  if (process.env.NODE_ENV === "development") {
    return LOCAL_STAGING_API_BASEURL;
  }
  return runtime;
}

const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.baseURL = getApiBaseUrl();

    const token = localStorage.getItem("matchCatchToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["timezone"] =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("matchCatchToken");
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
